<template>
  <div class="account-view">
    <form
      class="account-view__content"
      @submit.prevent="storeUserDetails()"
      v-if="userAccountDetails"
    >
      <div class="account-view__section">
        <RouterLink to="/login" class="back-button">
          <SvgIcon
            icon="icon--directional_arrow-left"
            class="is-primary-dark"
          />
          <span class="ml-2 has-text-primary-dark">
            {{ $t("account.backToDashboard") }}</span
          >
        </RouterLink>
        <div class="container mb-4">
          <h1 class="title is-3 has-text-grey">
            {{ $t("account.accountView.customerData") }}
          </h1>
          <h2 class="title is-5 has-text-grey is-uppercase">
            {{ $t("account.accountView.customer") }}
          </h2>
        </div>
      </div>
      <div class="account-view__section ">
        <div class="container">
          <div class="columns is-multiline">
            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3"
                  >{{
                    $t("checkout.paymentDetails.inputLabels.firstName")
                  }}
                  *</label
                >
                <div class="control">
                  <input
                    v-model="billingAddress.firstname"
                    class="input"
                    type="text"
                    maxlength="20"
                    :placeholder="
                      $t('checkout.paymentDetails.inputLabels.firstName')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3"
                  >{{
                    $t("checkout.paymentDetails.inputLabels.lastName")
                  }}
                  *</label
                >
                <div class="control">
                  <input
                    v-model="billingAddress.lastname"
                    class="input"
                    type="text"
                    maxlength="20"
                    :placeholder="
                      $t('checkout.paymentDetails.inputLabels.lastName')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{
                  $t("checkout.paymentDetails.inputLabels.phone")
                }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="tel"
                    :placeholder="
                      $t('checkout.paymentDetails.inputLabels.phone')
                    "
                    v-model="paymentDetails.phone"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="account-view__section">
        <div class="container mb-5">
          <h2 class="title is-5 has-text-grey is-uppercase">
            {{ $t("checkout.paymentDetails.billingAddress") }}
          </h2>
        </div>
        <div class="container">
          <div class="columns is-multiline">
            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3"
                  >{{
                    $t("checkout.paymentDetails.inputLabels.street")
                  }}
                  *</label
                >
                <div class="control">
                  <input
                    v-model="billingAddress.street"
                    class="input"
                    type="text"
                    :placeholder="
                      $t('checkout.paymentDetails.inputLabels.street')
                    "
                  />
                </div>
              </div>
            </div>

            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3"
                  >{{
                    $t("checkout.paymentDetails.inputLabels.postalCode")
                  }}
                  *</label
                >
                <div class="control">
                  <input
                    class="input"
                    v-model="billingAddress.postalCode"
                    type="text"
                    :placeholder="
                      $t('checkout.paymentDetails.inputLabels.postalCode')
                    "
                    :title="
                      'Gültige Postleitzahl aus ' +
                        'paymentDetails.billingCountry.name'
                    "
                  />
                  <!--:pattern="paymentDetails.bill_country.zipRegex"-->
                </div>
              </div>
            </div>

            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3"
                  >{{ $t("checkout.paymentDetails.inputLabels.city") }} *</label
                >
                <div class="control">
                  <input
                    v-model="billingAddress.city"
                    class="input"
                    type="text"
                    :placeholder="
                      $t('checkout.paymentDetails.inputLabels.city')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3"
                  >{{
                    $t("checkout.paymentDetails.inputLabels.country")
                  }}
                  *</label
                >
                <div class="control">
                  <select class="input" v-model="billingAddress.countryId">
                    <option
                      v-for="value in availableShippingCountries"
                      :value="value._id"
                      :key="`billing-country-option__${value._id}`"
                    >
                      {{ value.country }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-one-third-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{
                  $t("checkout.paymentDetails.inputLabels.company")
                }}</label>
                <div class="control">
                  <input
                    v-model="billingAddress.company"
                    class="input"
                    type="text"
                    :placeholder="
                      $t('checkout.paymentDetails.inputLabels.company')
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="account-view__section">
        <div class="container mt-5">
          <h2 class="title is-5 has-text-grey is-uppercase">
            {{ $t("checkout.paymentDetails.shippingAddress") }}
          </h2>
        </div>
      </div>
      <div class="account-view__section ">
        <div class="container">
          <div class="field has-checkbox">
            <label class="checkbox">
              <input
                class="control"
                type="checkbox"
                :value="isBillingAndShippingEqual"
                @click="toggleBillingAndShippingEqual"
              />
              {{
                $t(
                  "checkout.paymentDetails.inputLabels.shippingAddressDiffersFromBillingAddress"
                )
              }}
            </label>
          </div>
        </div>
        <transition name="fade">
          <div class="container" v-if="!isBillingAndShippingEqual">
            <div class="columns is-multiline">
              <div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3"
                    >{{
                      $t("checkout.paymentDetails.inputLabels.firstName")
                    }}
                    *</label
                  >
                  <div class="control">
                    <input
                      v-model="shippingAddress.firstname"
                      class="input"
                      type="text"
                      maxlength="20"
                      :placeholder="
                        $t('checkout.paymentDetails.inputLabels.firstName')
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3"
                    >{{
                      $t("checkout.paymentDetails.inputLabels.lastName")
                    }}
                    *</label
                  >
                  <div class="control">
                    <input
                      v-model="shippingAddress.lastname"
                      class="input"
                      type="text"
                      maxlength="20"
                      :placeholder="
                        $t('checkout.paymentDetails.inputLabels.lastName')
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3">{{
                    $t("checkout.paymentDetails.inputLabels.company")
                  }}</label>
                  <div class="control">
                    <input
                      v-model="shippingAddress.company"
                      class="input"
                      type="text"
                      :placeholder="
                        $t('checkout.paymentDetails.inputLabels.company')
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3"
                    >{{
                      $t("checkout.paymentDetails.inputLabels.street")
                    }}
                    *</label
                  >
                  <div class="control">
                    <input
                      v-model="shippingAddress.street"
                      class="input"
                      type="text"
                      :placeholder="
                        $t('checkout.paymentDetails.inputLabels.street')
                      "
                    />
                  </div>
                </div>
              </div>

              <!--div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3">Hausnummer *</label>
                  <div class="control">
                    <input class="input" v-model="paymentDetails.ship_house_number" type="text"
                           placeholder="Hausnummer">
                  </div>
                </div>
              </div-->

              <div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3"
                    >{{
                      $t("checkout.paymentDetails.inputLabels.postalCode")
                    }}
                    *</label
                  >
                  <div class="control">
                    <input
                      class="input"
                      v-model="shippingAddress.postalCode"
                      type="text"
                      :placeholder="
                        $t('checkout.paymentDetails.inputLabels.postalCode')
                      "
                      :title="
                        'Gültige Postleitzahl aus ' +
                          'paymentDetails.shippingCountry.name'
                      "
                    />
                    <!--:pattern="paymentDetails.shippingCountry.zipRegex"-->
                  </div>
                </div>
              </div>

              <div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3"
                    >{{
                      $t("checkout.paymentDetails.inputLabels.city")
                    }}
                    *</label
                  >
                  <div class="control">
                    <input
                      v-model="shippingAddress.city"
                      class="input"
                      type="text"
                      :placeholder="
                        $t('checkout.paymentDetails.inputLabels.city')
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="column is-one-third-tablet">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3"
                    >{{
                      $t("checkout.paymentDetails.inputLabels.country")
                    }}
                    *</label
                  >
                  <div class="control">
                    <select class="input" v-model="shippingAddress.countryId">
                      <option
                        v-for="value in availableShippingCountries"
                        :value="value._id"
                        :key="`shipping-country-option__${value._id}`"
                      >
                        {{ value.country }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="account-view__section">
        <div
          class="container has-text-right mb-5"
          v-if="!allRequiredFieldsAreFilled"
        >
          <span class="has-text-primary-dark">
            {{$t('checkout.requiredInput.someWith')}}
            <strong class="has-text-primary-dark">*</strong> 
            {{$t('checkout.requiredInput.notFilled')}}
          </span
          >
        </div>
        <div class="container has-text-right">
          <button
            :class="{ 'is-loading': isCurrentlySaving }"
            :disabled="!allRequiredFieldsAreFilled"
            class="button is-primary-dark px-6"
          >
            {{$t("processingSteps.actionLabels.saveConfiguration")}}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "../../events/event-bus";
import UStIDForm from "../Forms/UStIDForm";
import ModalView from "../shared/ModalView";
import SvgIcon from "../svg/SvgIcon";

export default {
  name: "AccountView",
  components: { UStIDForm, ModalView, SvgIcon },
  data() {
    return {
      paymentDetails: {
        email: "",
        phone: "",
        billingPaymentMethod: "prepaid",
      },
      billingAddress: {
        street: "",
        city: "",
        country: "",
        countryId: "",
        postalCode: "",
        company: "",
        addressSuffix: "",
        title: "",
        firstname: "",
        lastname: "",
        vatRegistrationNumber: "",
      },
      shippingAddress: {
        street: "",
        city: "",
        postalCode: "",
        company: "",
        addressSuffix: "",
        firstname: "",
        lastname: "",
        country: "",
        countryId: "",
      },
      isBillingAndShippingEqual: true,
      isCurrentlySaving: false,
      requiredShippingFields: [
        "firstname",
        "lastname",
        "street",
        "postalCode",
        "city",
        "countryId",
      ],
      requiredBillingFields: [
        "firstname",
        "lastname",
        "street",
        "postalCode",
        "city",
        "countryId",
      ],
    };
  },
  computed: {
    ...mapGetters([
      "isUserLoggedIn",
      "userAccountDetails",
      "availableShippingCountries",
      "shippingCountryById",
    ]),
    isBillingAndShippingEqualCheckbox: {
      get() {
        return !this.isBillingAndShippingEqual;
      },
      set() {
        this.toggleBillingAndShippingEqual();
      },
    },
    allRequiredFieldsAreFilled() {
      let result = true;
      this.requiredBillingFields.forEach((value) => {
        if (!this.billingAddress[value]) {
          result = false;
        }
      });
      if (!this.isBillingAndShippingEqual) {
        this.requiredShippingFields.forEach((value) => {
          if (!this.shippingAddress[value]) {
            result = false;
          }
        });
      }
      return result;
    },
  },
  watch: {
    isUserLoggedIn(value) {
      if (!value) {
        this.$router.push("/login");
      }
    },
  },
  methods: {
    fetchCMSData() {
      this.$store.dispatch("fetchCMSPage", { urlSlug: "/" });
    },
    async fetchShippingAndPaymentMethods() {
      await this.$store.dispatch("fetchShippingCountries");
    },
    fetchUserAccountDetails() {
      let vm = this;
      this.$store.dispatch("fetchUserAccountDetails").then(() => {
        let billCountry = null;
        let shipCountry = null;

        vm.billingAddress = {
          ...this.billingAddress,
          ...this.userAccountDetails["billingInformation"],
        };

        vm.shippingAddress = {
          ...this.shippingAddress,
          ...this.userAccountDetails["shippingInformation"],
        };

        vm.paymentDetails = {
          email:
            this.paymentDetails.email || this.userAccountDetails.email || "",
          phone:
            this.paymentDetails.phone || this.userAccountDetails.phone || "",
          userId:
            this.paymentDetails.userId ||
            this.userAccountDetails.userId ||
            null,
          billingPaymentMethod: "prepaid",
        };
      });
    },
    async storeUserDetails() {
      this.isCurrentlySaving = true;
      try {
        let userDetails = {
          ...this.paymentDetails,
          billingAddress: this.billingAddress,
          shippingAddress: this.shippingAddress,
        };
        if (this.isBillingAndShippingEqual) {
          userDetails.shippingAddress = this.billingAddress;
        }
        await this.$store.dispatch("updateUserAccountDetails", userDetails);

        eventBus.notification({
          type: "success",
          header: "Speichern erfolgreich",
          body: "Ihre Daten wurden gespeichert",
        });
      } catch (e) {
        eventBus.notification({
          type: "warning",
          header: "Hier scheint ein Fehler aufgetreten zu sein.",
          body:
            "Ihre Anfrage konnte nicht versendet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.",
        });
        console.log(e);
      }
      this.isCurrentlySaving = false;
    },
    toggleBillingAndShippingEqual() {
      this.isBillingAndShippingEqual = !this.isBillingAndShippingEqual;
    },
    closeModal() {
      this.showUStIDModal = false;
    },
    findCountryObject(name) {
      let country;
      Object.entries(this.shippingCountries).forEach((obj) => {
        if (obj[1].name === name) {
          country = obj;
        }
      });
      return country;
    },
  },

  async mounted() {
    await this.fetchUserAccountDetails();
    await this.fetchShippingAndPaymentMethods();
    if (!this.billingAddress.countryId) {
      this.billingAddress.countryId = this.availableShippingCountries[0]._id;
      this.shippingAddress.countryId = this.billingAddress.countryId;
    }
  },

  created() {
    this.fetchCMSData();
    let storedUserAccountDetails = this.$store.getters.userAccountDetails;
    if (Object.keys(storedUserAccountDetails).length > 0) {
      this.paymentDetails = {
        ...this.paymentDetails,
        ...storedUserAccountDetails,
      };
      this.billingAddress = {
        ...this.billingAddress,
        ...storedUserAccountDetails.billingAddress,
      };
      this.shippingAddress = {
        ...this.shippingAddress,
        ...storedUserAccountDetails.shippingAddress,
      };
    }
  },
};
</script>

<style></style>
